import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import api from '../../../../api';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';
import { useAuth } from '../../../Layouts/context/Authcontext';

const COLORS = ['#EE1D23', '#1A2B5C'];

const WorkedDaysDonutChart = ({ filters }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { accessToken } = useAuth();

  useEffect(() => {
    const fetchWorkedDaysData = async () => {
      try {
        setIsLoading(true);
        const baseUrl = getRoundRobinBaseUrl();
        const queryParams = new URLSearchParams(filters).toString();
        const response = await api.get(`${baseUrl}/superAdminDashboard/getSuperAdminWorkedDaysAndNoLate?${queryParams}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (response.data?.success && response.data.data) {
          const res = response.data.data;
          setData([
            { name: 'Worked Days', value: Number(res.workingDayCount) },
            { name: 'No Late', value: Number(res.lateCount) },
          ]);
        } else {
          setData(null);
        }
      } catch (err) {
        console.error('Error fetching worked days chart:', err);
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWorkedDaysData();
  }, [accessToken, filters]); // ✅ fixed: ensure hook closes properly

  const LoadingDots = () => (
    <div className="flex justify-center items-center space-x-2">
      <div className="w-4 h-4 bg-[#2563EB] rounded-full animate-bounce"></div>
      <div className="w-4 h-4 bg-[#38BDF8] rounded-full animate-bounce [animation-delay:0.2s]"></div>
      <div className="w-4 h-4 bg-[#2563EB] rounded-full animate-bounce [animation-delay:0.4s]"></div>
    </div>
  );

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6">
      <h3 className="text-lg font-bold mb-4 text-[#1A2B5C]">Worked Days / No Late</h3>
      <div className="h-60 flex items-center justify-center">
        {isLoading ? (
          <LoadingDots />
        ) : data ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={2}
                dataKey="value"
                label
                isAnimationActive
                animationDuration={1200}
              >
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              {/* <Legend /> */}
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-sm text-gray-400">No data available</p>
        )}
      </div>

      {/* 👇 Value summary below the chart */}
      {!isLoading && data && (
        <div className="mt-4 flex justify-center gap-8 text-sm font-medium text-gray-700">
          {data.map((item, index) => (
            <div key={item.name} className="flex items-center gap-2">
              <span
                className="inline-block w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></span>
              <span>
                {item.name}: {item.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkedDaysDonutChart;
